import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const CustomTermsTextStyled = styled(Typography)(() => ({
  fontSize: '14px',
}));
